var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "image-upload-info-container" },
    [
      _c(
        "ul",
        { staticClass: "el-upload-list el-upload-list--picture-card" },
        [
          _c(
            "draggable",
            {
              model: {
                value: _vm.fileList,
                callback: function($$v) {
                  _vm.fileList = $$v
                },
                expression: "fileList"
              }
            },
            _vm._l(_vm.fileList, function(item, index) {
              return _c(
                "li",
                {
                  key: item.uid,
                  staticClass: "el-upload-list__item is-success animated"
                },
                [
                  _c("img", {
                    staticClass: "el-upload-list__item-thumbnail",
                    attrs: { src: item.url, alt: "" }
                  }),
                  _c("i", { staticClass: "el-icon-close" }),
                  _c("span", { staticClass: "el-upload-list__item-actions" }, [
                    _c(
                      "span",
                      {
                        staticClass: "el-upload-list__item-delete",
                        on: {
                          click: function($event) {
                            return _vm.pictureRemove(_vm.fileList[index])
                          }
                        }
                      },
                      [_c("i", { staticClass: "el-icon-delete" })]
                    )
                  ])
                ]
              )
            }),
            0
          )
        ],
        1
      ),
      _vm.fileList.length < _vm.limit
        ? _c(
            "el-upload",
            {
              ref: "upload",
              class: { uploadContainer: _vm.hideAddDiv },
              attrs: {
                action: _vm.env.VUE_APP_fileserver + "persistentUpload",
                "list-type": "picture-card",
                limit: _vm.limit,
                "file-list": _vm.fileList,
                "show-file-list": false,
                "on-success": _vm.uploadSuccess,
                "on-remove": _vm.pictureRemove,
                "before-upload": _vm.pictureBeforeUpload
              }
            },
            [_c("i", { staticClass: "el-icon-plus" })]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }